import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { urlLog } from '../common';

@Injectable({
  providedIn: 'root'
})
export class UserLogService {

  constructor(private http: HttpClient) { }

  createUserLog(data: any) {
    return this.http.post(`${urlLog}/createLogUSer`, data);
  }

  showUserLog() {
    return this.http.get(`${urlLog}/listAllLog`);
  }

  showUserLogByFilter(data: any) {
    return this.http.post(`${urlLog}/listFilterLog`, data);
  }

  getLastLogByContent(idContent: number, term: string, idTier3?: number | string) {
    let url = `${urlLog}/lastLog/${idContent}/${term}`;
    if (idTier3) url += `/${idTier3}`;
    return this.http.get(url);
  }
  
  getLogByT3(id: number) {    
    return this.http.get(`${urlLog}/log-by-t3/${id}`);
  }

  getLogBySubsections(subsectionIds: number[]) {
    return this.http.post(`${urlLog}/log-by-idsubsection`, { subsectionIds });
  }
  
}
